
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {get,post} from './api'
export default {
components: {
Flexbox,
FlexboxItem,
XInput,
XButton,
Group,
Cell,
XImg,
Toast
},
mounted() {
this.Tag = this.$route.query.tag;
if(this.Tag=='M'){
this.isManager=true;
this.isBusiness=false;
}
else if(this.Tag=='B'){
this.isManager=false;
this.isBusiness=true;
}
},
methods: {
Login(){
if(this.isBusiness==true){
post('/Business/login', this.BusinessInfo).then(response => {

if(response.code==1){
this.GLOBAL.currentUser=response.data;
this.showSuccess=true;
this.$router.push({ path: '/MainPage?tag=B' });
}
else if(response.code==0){
this.showError=true;
}
else if(response.code==1001){
this.WarnInfo=response.message;
this.showWarn=true;
}
}).catch(error => {
console.log(error);
});
}
else if(this.isManager==true){
post('/User/login', this.UserInfo).then(response => {

if(response.code==1){
this.GLOBAL.currentUser=response.data;
this.showSuccess=true;
this.$router.push({ path: '/MainPage?tag=M' });
}
else if(response.code==0){
this.showError=true;
}
else if(response.code==1001){
this.WarnInfo=response.message;
this.showWarn=true;
}
}).catch(error => {
console.log(error);
});
}
},
Regedit(){
this.$router.push({ path: '/BusinessDetail?tag=R' });
}
},
data () {
return {
BusinessInfo:{
FilterKey:"",
Password:""
},
UserInfo:{
FilterKey:"",
Password:""
},
Tag:'',
showSuccess:false,
showWarn:false,
showError:false,
SuccessInfo:'登录成功!',
WarnInfo:'',
ErrorInfo:'系统异常,联系管理员!',
isBusiness:false,
isManager:false
}
}
}



// WEBPACK FOOTER //
// ./src/components/LoginPage.vue